<template>
  <div class="max-w-3xl mx-auto">
    <div
      v-for="order in placedOrders"
      :key="order.orderDate"
      class="mb-16">
      <h3 class="mb-4 text-2xl text-center font-bold">{{ formatAsDateTitle(order.orderDate) }}</h3>
      <div class="pl-12" v-for="(groupedProducts, key, index) in order.groupedProducts" :key="index">
        <h4 class="font-bold text-xl mt-10 mb-4">{{ key }}</h4>
        <table class="table-auto w-full">
          <thead>
            <tr class="pb-4 print:border-b print:border-black">
              <th class="w-3/4 pb-2 text-accent-brown print:text-sm print:w-full text-left">Artikelname</th>
              <th class="w-1/4 pb-2 text-right text-accent-brown print:text-sm print:w-16">Stück</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in groupedProducts" :key="product.item.id">
              <td class="py-4 border-b border-gray-300 print:border-black right text-lg print:py-1 print:text-sm">
                {{ product.item.name }} ({{ product.item.item_number }})
              </td>
              <td class="py-4 border-b border-gray-300 print:border-black text-right text-lg print:py-1 print:text-sm">
                <span v-if="product.originalQuantity !== product.newQuantity && order.submitted">
                  <span class="line-through text-gray-400 inline-block mr-1">{{ product.originalQuantity }}</span>
                  <span class="font-semibold text-red-600">{{ product.newQuantity }}</span>
                </span>
                <span v-else class="font-semibold">{{ product.newQuantity }}</span>
              </td>
            </tr>
            <tr>
              <td class="py-4 right text-lg print:py-1 print:text-s font-semibold">
                Summe ({{ key }})
              </td>
              <td class="font-semibold py-4 text-right text-lg print:py-1 print:text-sm">
                {{ sumOfGroupQuantities(groupedProducts) }}
              </td>
            </tr>
            <!-- <tr v-if="!order.products || order.products.length === 0">
              <td class="py-4 border-b border-gray-300 print:border-black right text-lg print:py-1 print:text-sm">
                -
              </td>
              <td class="py-4 border-b border-gray-300 print:border-black text-right text-lg print:py-1 print:text-sm">
                -
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>
      <div v-if="!order.groupedProducts || Object.keys(order.groupedProducts).length === 0" class="text-center text-xl"> - </div>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import deLocale from 'date-fns/locale/de'

import ordersStockStore from '@/Store/ordersStock'
import { parse } from 'date-fns/esm/fp'

const orderState = ordersStockStore.state

export default {
  name: 'CartContent',
  inject: ['systemStatus'],
  props: {},

  data: () => ({
    orderState
  }),

  computed: {
    /**
     * Use submitted to check if it is an already submitted order or not
     * Quantity changes of an product can be found
     *
     * Example of placed orders:
     *
     * [{
     *   orderDate: Date,
     *   orderId: Int,
     *   submitted: Bool,
     *   editable: Bool,
     *   hasChanges: Bool,
     *   groupedProducts: {
     *     "Kategoriename": [{item: Object, originalQuantity: int, newQuantity: int}]
     *   }
     * }]
     */
    placedOrders() {
      return ordersStockStore.getValidWeekOrders(this.systemStatus.next_order_day)
    }
  },

  methods: {
    formatAsDateTitle(date) {
      return format(date, 'EEEE, dd.MM.yyyy', {
        locale: deLocale
      })
    },

    sumOfGroupQuantities(products) {
      let sum = 0

      for (const product of products) {
        sum = sum + parseInt(product.newQuantity)
      }

      return sum
    }
  }
}
</script>
